export class RemoteConfig {
    constructor() {
        this.holiday = 0;
        this.holidayName = "";
        this.holidayWeek = "1";
        this.isADEnable = false;
        this.isDelayClose = false;
        this.isShielding = false;
        this.isNavEnable = false;
        this.gamecenterLevel = 100;
        this.nativePayRate = 0;
        this.nativeClickCount = 0;
        this.changeEnable = true;
        this.shieldHours = [];
        this.severTime = "";
        this.payRate = 0;
        /**游戏中心关卡 */
        this.navLevels = [];
    }
}
